export enum EventPoints {
  ORDER_CREATE = 'order/create',
  ORDERS_GET = 'orders/get',
}



// WEBPACK FOOTER //
// ./src/services/orders/types.ts